import React, { PropsWithChildren } from "react";
import { Container } from "../container";

export const IntroText: React.FC<PropsWithChildren> = ({
  children,
  ...props
}) => {
  // console.log("intro", { children });
  return (
    <Container
      className="mt-4 grid grid-cols-4 gap-16 leading-10 lg:mt-10"
      {...props}
    >
      <div className="hidden lg:block" />
      <div className="markdown col-span-4 text-m font-bold lg:col-span-2 lg:text-base">
        {children}
      </div>
    </Container>
  );
};
